import { Col, Row, Typography } from "antd";
import { MutableRefObject, useState, useContext, CSSProperties } from "react";
import { useSelector } from "react-redux";

import {
  ChangeStateContext,
  exchangeRateContext,
  returnedContext,
  tenderedLBPContext,
} from "./MainFour";
import image from "../../images/pos logo1 1.png";
import { useTranslation } from "react-i18next";
import { getReceiptCurrLS, getReceiptLangLS } from "../../utils/main-utils";

type CurrencyType = {
  abbreviation: string;
  id: number;
  name: string;
  symbol: string;
};
interface Props {
  componentRef: MutableRefObject<any>;
  exchangeRate: number;
  secondaryCurrency: CurrencyType;
  mainCurrency: CurrencyType;
  dateString: string;
  timeString: string;
  deliveryCharge: number | null;
  totalTax: any
}
const InvoicePrintSimple = ({
  dateString,
  timeString,
  componentRef,
  secondaryCurrency,
  mainCurrency,
  deliveryCharge,
  totalTax
}: Props) => {

  if(getReceiptCurrLS() === "lbp"){
    const temp = mainCurrency
    mainCurrency = secondaryCurrency
    secondaryCurrency = temp
  }

  const subTitlesStyles: CSSProperties = {
    borderBottom: "1px #000 solid",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: '10px'
  };

  const itemStyles: CSSProperties = { borderBottom: "1px #000 dotted", fontSize: '10px' };
  const dataStyles: CSSProperties = { textAlign: "center", fontSize: '10px' };

  const leftColTable = {
    borderBottom: "1px #000 dotted",
    borderTop: "1px #000 solid",
    borderRight: "1px #000 solid",
    fontSize: '10px'
  };
  const RightColTable = {
    borderBottom: "1px #000 dotted",
    borderTop: "1px #000 solid",
    display: "flex",
    justifyContent: "center",
    fontSize: '10px'
  };

  const [username] = useState(localStorage.getItem("userName"));
  const { exchangeRate } = useContext(exchangeRateContext);
  const { returnedLBP, overpaymentUSD } = useContext(returnedContext);
  const { tenderedUSD } = useContext(ChangeStateContext);
  const { tenderedLBP } = useContext(tenderedLBPContext);

  const items = useSelector((state: any) => state.main.items);
  const finalPrice = useSelector((state: any) => state.main.finalPrice);
  const customer = useSelector((state: any) => state.main.customer);
  const totalPrice = useSelector((state: any) => state.main.totalPrice);
  const discount = useSelector((state: any) => state.main.discount);

  const ReduxDeliveryCharge = useSelector((state: any) => state.main.deliveryCharge)

  const receiptHeaderCompanyName = localStorage.getItem(
    "receiptHeaderCompanyName"
  );

  const totalItemQty = (): number => {
    let totalQty = 0;

    for (const item of items) {
      totalQty += item.qty;
    }
    return totalQty;
  };
  function getDeadBalance(num: number) {
    const deadBalance = Number((num % 1).toFixed(3));
    return deadBalance > 0 ? deadBalance : 0;
  }

  function numberWithCommas(x: number) {
    return x === 0 ? '0.00' : x.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
  function numberWithCommasLBP(x: number) {
    return x && x.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  const [t] = useTranslation("common");

  const receiptLang = getReceiptLangLS()

  const invoiceNo = useSelector((state: any) => state.main.invoiceNo);

  return (
    <div ref={componentRef}
      dir={receiptLang === 'ar' ? "rtl" : "ltr"}
    >
      <Row justify={"center"}>
        <Typography.Title style={{ margin: 0 , fontSize: '24px'}} level={3}>
        #: {Number(invoiceNo?.substr(invoiceNo?.length - 3,3)) + 100}
        </Typography.Title>
      </Row>

      <Row justify={"center"}>
        <Typography.Title style={{ margin: 0 }} level={2}>
          {receiptHeaderCompanyName === "null" ? "" : receiptHeaderCompanyName}
        </Typography.Title>
      </Row>

      <Row justify={"center"} style={{ marginBottom: "10px", fontSize: '10px' }}>
        <Col span={24} style={{ fontSize: '10px' }}> {customer?.name}</Col>
      </Row>

      <Row justify={"center"} gutter={[5, 0]} style={{ fontSize: '10px' }}>
        <Col span={13} style={{ fontSize: '10px' }}>{t('invoice', { lng: receiptLang })}#: {invoiceNo}</Col>
        <Col span={11} style={{ fontSize: '10px' }}>{t('user', { lng: receiptLang })}: {username}</Col>
      </Row>

      <Row justify={"start"} gutter={[5, 0]} style={{ fontSize: '10px' }}>
        <Col span={13} style={{ fontSize: '10px' }}>{t('register', { lng: receiptLang })}#: 01</Col>
      </Row>      

      <Row justify={"center"} style={{ fontSize: '10px' }}>
        <Col span={11} style={subTitlesStyles}>
          {t('description', { lng: receiptLang })}
        </Col>
        <Col span={4} style={subTitlesStyles}>
          {t('qty', { lng: receiptLang })}
        </Col>
        <Col span={4} style={subTitlesStyles}>
          {t('u-price', { lng: receiptLang })}
        </Col>
        <Col span={5} style={subTitlesStyles}>
          {t('total', { lng: receiptLang })}
        </Col>
      </Row>

      {/* Map inside this section */}
      {items.map((item: any) => (
        <Row style={itemStyles}>
          <Col span={11} style={{ textAlign: "center", fontSize: "10px" }}>
            {item?.isTaxable ? "*" : ""}{item?.name}
          </Col>
          <Col span={4} style={dataStyles}>
            {numberWithCommas(item.qty)}
          </Col>
          <Col span={4} style={dataStyles}>
            {getReceiptCurrLS() === 'usd' ? numberWithCommas(item.price) : numberWithCommasLBP(item.price * exchangeRate)}
          </Col>
          <Col span={5} style={dataStyles}>
            {getReceiptCurrLS() === 'usd'? numberWithCommas(item.qty * item.price) : numberWithCommasLBP(item.qty * item.price * exchangeRate)}
          </Col>
        </Row>
      ))}

      {/* Map inside this section */}
      {discount?.amount ? (
        <Row justify={"end"} style={{ fontSize: '10px' }}>
          <Col span={6} style={{ fontSize: '10px' }}>{t('subtotal', { lng: receiptLang })} {mainCurrency?.symbol}:</Col>
          <Col span={5} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommas(Number(totalPrice)) : numberWithCommasLBP(Number(totalPrice * exchangeRate))}</Col>
        </Row>
      ) : (
        ""
      )}

      {deliveryCharge ? (
        <Row justify={"end"} style={{ fontSize: '10px' }}>
          <Col span={6} style={{ fontSize: '10px' }}>{t('delivery', { lng: receiptLang })} {mainCurrency?.symbol}:</Col>
          <Col span={5} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommas(Number(deliveryCharge)) : numberWithCommasLBP(Number(deliveryCharge * exchangeRate))}</Col>
        </Row>
      ) : (
        ""
      )}

      {ReduxDeliveryCharge ? (
        <Row justify={"end"} style={{ fontSize: '10px' }}>
          <Col span={6} style={{ fontSize: '10px' }}>{t('delivery', { lng: receiptLang })} {mainCurrency?.symbol}:</Col>
          <Col span={5} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommas(ReduxDeliveryCharge) : numberWithCommasLBP(ReduxDeliveryCharge * exchangeRate)}</Col>
        </Row>
      ) : (
        ""
      )}

      {discount?.amount ? (
        <Row justify={"end"} style={{ fontSize: '10px' }}>
          <Col span={6} style={{ fontSize: '10px' }}>{t('discount', { lng: receiptLang })} {discount?.type === "#" ? mainCurrency.symbol : "%"}:</Col>
          <Col span={5} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommas(discount?.amount) : numberWithCommasLBP(discount?.amount * exchangeRate)}</Col>
        </Row>
      ) : (
        ""
      )}

      <Row justify={"end"} style={{ fontSize: '10px' }}>
        <Col span={6} style={{ fontSize: '10px' }}>{t('total', { lng: receiptLang })} {mainCurrency?.symbol}:</Col>
        <Col span={5} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommas(Number(finalPrice)) : numberWithCommasLBP(Number(finalPrice) * exchangeRate)}</Col>
      </Row>

      <Row justify={"end"} style={{ fontSize: '10px' }}>
        <Col span={6} style={{ fontSize: '10px' }}>{t('rate', { lng: receiptLang })}:</Col>
        <Col span={5} style={{ fontSize: '10px' }}>{numberWithCommasLBP(exchangeRate)}</Col>
      </Row>

      <Row justify={"end"} style={{ fontSize: '10px' }}>
        <Col span={6} style={{ fontSize: '10px' }}>{t('total', { lng: receiptLang })} {secondaryCurrency?.symbol}:</Col>
        <Col span={5} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommasLBP(Number(finalPrice * exchangeRate)) : numberWithCommas(Number(finalPrice))}
        </Col>
      </Row>

      <Row justify={"center"} style={{ fontSize: '10px' }}>
        <Col span={12} style={{ textAlign: "center", fontSize: '10px' }}>
          {t('payment-type', { lng: receiptLang })}
        </Col>
        <Col span={12} style={{ textAlign: "center", fontSize: '10px' }}>
          {t('value', { lng: receiptLang })}
        </Col>
        <Col span={12} style={leftColTable}>
          {t('cash', { lng: receiptLang })} {mainCurrency?.symbol}:
        </Col>
        <Col span={12} style={RightColTable}>
          {getReceiptCurrLS() === 'usd' ? numberWithCommas(
            Number(tenderedUSD) + Number(tenderedLBP) / Number(exchangeRate)
          ) : numberWithCommasLBP(Number(tenderedUSD) * Number(exchangeRate) + Number(tenderedLBP)) }
        </Col>
        <Col span={12} style={leftColTable}>
          {t('change', { lng: receiptLang })} {mainCurrency?.symbol}:
        </Col>
        <Col span={12} style={RightColTable}>
          {getReceiptCurrLS() === 'usd' ? numberWithCommas(
            Number(overpaymentUSD) + Number(returnedLBP) / exchangeRate
          ) : numberWithCommasLBP(Number(overpaymentUSD * exchangeRate) + Number(returnedLBP))}
        </Col>
      </Row>

      {/* <Row justify={"start"} style={{ fontSize: '10px' }}>
        <Col span={9} style={{ fontSize: '10px' }}>{t('dead-balance', { lng: receiptLang })}: </Col>
        <Col span={3} style={{ fontSize: '10px' }}>{getReceiptCurrLS() === 'usd' ? numberWithCommas(getDeadBalance(tenderedUSD - finalPrice)) : numberWithCommasLBP(getDeadBalance((tenderedUSD - finalPrice) * exchangeRate))}</Col>
      </Row> */}

      <Row justify={"start"} style={{ fontSize: '10px' }}>
        <Col span={9} style={{ fontSize: '10px' }}>#{t('items', { lng: receiptLang })}:</Col>
        <Col span={3} style={{ fontSize: '10px' }}>{totalItemQty().toFixed(0)}</Col>
      </Row>
      <Row justify={"start"} >
        <Col style={{ fontSize: '10px' }}>{t('date', { lng: receiptLang })}: {dateString} {timeString}</Col>
      </Row>

      <Row justify={"center"} style={{ fontSize: '10px' }}>
        <Typography.Title level={3} style={{ fontSize: '12px', marginTop: '2rem' }}>{t('thank-you', { lng: receiptLang })}</Typography.Title>
        <Row justify={"center"} style={{ fontSize: '8px' }}>
          <img src={image} alt="" width={83.2} />
        </Row>
      </Row>

    </div>
  );
};

export default InvoicePrintSimple;
